module.exports = __webpack_public_path__ + "img/greencheck.7d204b41.svg";